import { Heading } from "@digipost/dds-heading-react";
import { FC, ReactNode } from "react";

import { DigipostEntryPoint } from "../../../types/entrypoint";
import {
  SiteImproveActions,
  SiteImproveCategories,
  siteImproveEvent,
} from "../analytics/siteimprove";
import { useEntrypointContext } from "../EntrypointContext";
import Translated from "../infrastructure/components/Translated";
import { TranslateTextKeyType } from "../infrastructure/hooks/translator";
import { findURIWithWindowHostname } from "../infrastructure/link";
import ChevronRight from "./chevron-right.svg?react";
import { LoginMethod, LoginRole } from "./LoginMethod";
import styles from "./Virksomhet.module.less";

export const LoginCard: FC<{
  loginMethod: LoginMethod;
  loginRole: LoginRole;
  returnUrl: string;
  description: TranslateTextKeyType;
  title: TranslateTextKeyType;
  icon: ReactNode;
}> = ({ description, icon, title, returnUrl, loginRole, loginMethod }) => {
  const entrypoint: DigipostEntryPoint = useEntrypointContext();

  const redirectToAuthentication = (): void => {
    const url = findURIWithWindowHostname("login_idp", entrypoint.link);

    window.location.href = `${url}?provider=signicat&rolle=${loginRole}&returnUrl=${returnUrl}&idpPreselect=${loginMethod}`;
  };

  return (
    <button
      className={styles.loginCard}
      onClick={() => {
        siteImproveEvent({
          action: SiteImproveActions.BUTTON,
          category: SiteImproveCategories.LOGIN_BUSINESS_USER,
          label: `trykker på knapp for å logge inn med ${title}`,
        });
        redirectToAuthentication();
      }}
    >
      <div className={styles.textCard}>
        <div className={styles.loginCardIcon}>{icon}</div>
        <span aria-hidden="true" role="presentation" />
        <div>
          <Heading level={3} size={"xsmall"}>
            <Translated textKey={title} />
          </Heading>
          <Translated textKey={description} />
        </div>
      </div>
      <div className={styles.chevron}>
        <ChevronRight />
      </div>
    </button>
  );
};
